/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 *
 * Drift control: cds-ai-service/backend/v4/agents/runs/keys.js (buildRunCrn).
 */

// Matches run#{agentRef}#{runRef} from ai-service buildRunCrn
const RUN_CRN_PATTERN = /^run#[^#]+#[^#]+$/;

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export const isRunCrnRef = value => {
  if (typeof value !== 'string') {
    return false;
  }

  const trimmed = value.trim();

  return trimmed !== '' && RUN_CRN_PATTERN.test(trimmed);
};

/**
 * Returns a chat message ref only when value is a non-empty, non-run CRN string.
 * @param {unknown} value
 * @returns {string | null}
 */
export const resolveChatMessageRef = value => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();

  if (trimmed === '' || isRunCrnRef(trimmed)) {
    return null;
  }

  return trimmed;
};

/**
 * Feedback payload messageRef: prefer metadata.messageRef, then message.crn; never run CRN.
 * @param {{ crn?: string, metadata?: { messageRef?: string } } | null | undefined} message
 * @returns {string}
 */
export const buildFeedbackMessageRef = message => {
  const metadata = message?.metadata && typeof message.metadata === 'object' ? message.metadata : {};

  const fromMetadata = resolveChatMessageRef(metadata.messageRef);

  if (fromMetadata) {
    return fromMetadata;
  }

  const fromCrn = resolveChatMessageRef(message?.crn);

  if (fromCrn) {
    return fromCrn;
  }

  return '';
};
